const gerar_arquivo_texto_de_alunos_com_cpf = [
  {
    path: "/gerar-arquivo-texto-de-alunos-com-cpf",
    name: "gerar_arquivo_texto_de_alunos_com_cpf",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_gerar_arquivo_alunos_com_cpf"],
    },
    component: () =>
      import(
        "@/views/GerarArquivoTextoDeAlunosComCPF/GerarArquivoTextoDeAlunosComCPF.vue"
      ),
  },
];

export { gerar_arquivo_texto_de_alunos_com_cpf };
